<template>
  <router-link
    v-if="to"
    :id="id"
    :class="buttonClass"
    :to="to"
    :role="nativeType"
    :target="target"
    :rel="rel"
  >
    <FontIcon :name="icon" v-if="icon" />
    <slot />
  </router-link>

  <a
    v-else-if="url"
    :id="id"
    :class="buttonClass"
    :href="url"
    :role="nativeType"
    :target="target"
    :rel="rel"
  >
    <FontIcon :name="icon" v-if="icon" />
    <slot />
  </a>

  <button
    v-else
    :id="id"
    :class="buttonClass"
    :disabled="disabled"
    :type="nativeType"
  >
    <FontIcon :name="icon" v-if="icon" />
    <slot />
  </button>
</template>

<script>
import FontIcon from "../FontIcon/FontIcon";

const TEXT_SIZE = {
  primary: "text6",
  secondary: "text6",
  tertiary: "text8",
};

export default {
  components: {
    FontIcon,
  },

  props: {
    type: {
      type: String,
      default: "primary",
      validator(type) {
        return [
          "primary",
          "primary-negative",
          "secondary",
          "secondary-negative",
          "tertiary",
          "tertiary-negative",
        ].includes(type);
      },
    },
    nativeType: {
      type: String,
      default: "button",
      validator(nativeType) {
        return ["button", "submit", "reset"].includes(nativeType);
      },
    },
    id: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
    to: {
      default: null,
    },
    url: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: "_self",
    },
  },

  computed: {
    buttonClass() {
      return [
        "button",
        `button-${this.type}`,
        this.disabled && "button--disabled",
        this.icon && "button--with-icon",
        this.className,
        TEXT_SIZE[this.type],
      ];
    },
    rel() {
      return this.target === "_blank" ? "noopener noreferrer" : null;
    },
  },
};
</script>
